import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { SmartphoneIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react';
const pillars = [{
  title: 'Mobile-First Builder',
  description: 'Crafting intuitive, native-feeling experiences that users love to engage with daily. I focus on performance, accessibility, and fluid interactions.',
  icon: SmartphoneIcon,
  iconBg: 'bg-accent',
  borderColor: 'border-accent'
}, {
  title: 'Regulatory Navigator',
  description: 'Transforming complex compliance requirements into invisible, frictionless user flows. I thrive in healthcare, finance, and enterprise constraints.',
  icon: ShieldCheckIcon,
  iconBg: 'bg-accent-secondary',
  borderColor: 'border-accent-secondary'
}, {
  title: 'Customer Obsessed',
  description: 'Rooting every product decision in deep qualitative research and quantitative data. I build for the user, not just the specification.',
  icon: UsersIcon,
  iconBg: 'bg-dark',
  borderColor: 'border-dark'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function About() {
  return <section id="philosophy" className="py-20 md:py-32 bg-warm" data-id="element-11">
      <div className="max-w-6xl mx-auto px-6" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-16 md:mb-24" data-id="element-13">
          <h2 className="text-3xl md:text-4xl font-serif text-text-primary mb-10" data-id="element-14">
            Product Philosophy
          </h2>
          <blockquote className="text-2xl md:text-3xl font-serif italic text-text-primary leading-snug max-w-3xl border-l-4 border-accent pl-6 py-2" data-id="element-15">
            "Great products are negotiated, not just built. They exist at the
            intersection of strict constraints and human empathy."
          </blockquote>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-16">
          {pillars.map((pillar, index) => <motion.div key={index} variants={itemVariants} className={`flex flex-col bg-card p-8 border-l-4 ${pillar.borderColor} shadow-warm-sm`} data-id="element-17">
              <div className={`w-12 h-12 rounded-lg ${pillar.iconBg} flex items-center justify-center mb-6`} data-id="element-18">
                <pillar.icon className="w-6 h-6 text-white" data-id="element-19" />
              </div>
              <h3 className="text-xl font-serif text-text-primary mb-3" data-id="element-20">
                {pillar.title}
              </h3>
              <p className="text-text-secondary leading-relaxed" data-id="element-21">
                {pillar.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}